import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import ListingCard from '@/components/listings/ListingCard';
import { Package } from 'lucide-react';

const DashboardListingsTab = ({ listings }) => {
    const navigate = useNavigate();

    if (listings.length === 0) {
        return (
            <Card className="rounded-2xl">
                <CardContent className="py-12 text-center">
                    <Package className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
                    <h3 className="font-semibold mb-2">Nu ai listări încă</h3>
                    <p className="text-muted-foreground mb-4">Începe să vinzi produse pe Colectarium</p>
                    <Button className="rounded-full" onClick={() => navigate('/create-listing')}>
                        Listează primul produs
                    </Button>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {listings.map(listing => (
                <ListingCard key={listing.listing_id} listing={listing} />
            ))}
        </div>
    );
};

export default DashboardListingsTab;
